import { render, staticRenderFns } from "./UGCArtworkVotesReport.vue?vue&type=template&id=077941b6"
import script from "./UGCArtworkVotesReport.vue?vue&type=script&lang=js"
export * from "./UGCArtworkVotesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports